import React, { useEffect, useState} from 'react';
import { isEmpty } from 'lodash'
import { TableHead, TableBody, TableRow, TableCell, Box, Typography, IconButton } from '@material-ui/core';
import { Autorenew, ListAltRounded, ListRounded } from '@material-ui/icons';
import { ListLayout } from '../containers/Layout';
import Spin from '../../../../commonModules/interface/Spin';
import SingleSalePopUp from '../sales/SingleSalePopUp';

const NATURE = {
    "installation": "Installation",
    "vente": "Vente",
    "payg": "Vente PayG"
}
const ClientHistory = (props) => {
    const [state,setState] = useState({   
        view: "sale",
        singleSale: "",
        openSale: false
    })
    useEffect(() => {
        if (isEmpty(props.historySale)){
        }
    }, []);
    
    const openSale = ( saleID ) => {
        setState(prevState => ({...prevState,
            singleSale: saleID,
            openSale: !!saleID
        }))
    }
        return (
            <Box>
                {openSale && !isEmpty(state.singleSale) &&
                    <SingleSalePopUp saleID={state.singleSale} closeSale={() => openSale()}/>                    
                }
                {(!props.history || props.loading) ?
                    <Spin noOverlay />
                    :
                    <Box style={{ textAlign: "right"}}>
                        <Box style={{ justifyContent: "space-between", display: "flex"}}>
                            <Box>
                                {state.view === "sale" &&
                                    <IconButton 
                                        color="secondary"
                                        title="Vue Produits"
                                        onClick={()=>
                                            setState({ view: "product" })
                                        }
                                    >
                                        <ListRounded />
                                    </IconButton> 
                                } 
                                {state.view === "product" &&
                                <IconButton 
                                    color="secondary" 
                                    title="Vue Ventes"
                                    onClick={()=>
                                        setState({ view: "sale" })
                                    }
                                >
                                    <ListAltRounded />
                                </IconButton> 
                                } 
                            </Box>
                            {/* <GroupRadio 
                                name="view"
                                value={state.view}
                                onChange={(e) => setState({ view: e.target.value })}
                            >
                                <SingleRadio label="Vente" value="sale" />
                                <SingleRadio label="Produit" value="product"/>
                            </GroupRadio> */}
                            <IconButton color="secondary" onClick={props.refreshData}>
                                <Autorenew />
                            </IconButton>
                        </Box>
                        {!isEmpty(props.historySale) && state.view === "sale" &&
                            <ListLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell component="th">Date</TableCell>
                                        <TableCell component="th">Opération</TableCell>
                                        <TableCell component="th">Prix</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.historySale.map( (op, i) => 
                                        <TableRow 
                                            key={op.history_id}
                                            onClick={() => openSale(op.history_id)}
                                            hover
                                        >
                                            <TableCell>{new Date(op.history_date).toLocaleDateString("fr-FR")}</TableCell>
                                            <TableCell>{NATURE[op.operation]}</TableCell>
                                            <TableCell>{op.total ? op.total.toLocaleString('fr-FR'):""}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </ListLayout>
                        }
                        {!isEmpty(props.history) && state.view === "product" &&
                            <ListLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell component="th">Date</TableCell>
                                        <TableCell component="th">Opération</TableCell>
                                        <TableCell component="th">Nom</TableCell>
                                        <TableCell component="th">Référence</TableCell>
                                        <TableCell component="th">Quantité</TableCell>
                                        <TableCell component="th">Prix</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.history.map( (op, i) => 
                                        <TableRow 
                                            key={`${op.history_product}_${i}`}
                                            onClick={() => openSale(op.history_id)}
                                            hover
                                        >
                                            <TableCell>{new Date(op.history_date).toLocaleDateString("fr-FR")}</TableCell>
                                            <TableCell>{NATURE[op.operation]}</TableCell>
                                            <TableCell>{op.product && op.product.name}</TableCell>
                                            <TableCell>{op.product && op.product.ref}</TableCell>
                                            <TableCell>{op.history_quantity}</TableCell>
                                            <TableCell>{op.price.toLocaleString('fr-FR')}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </ListLayout>
                        }
                    </Box>
                }
                
            </Box>
        );
}

export default ClientHistory;